/** Clés des palettes par défaut Mantine (DEFAULT_THEME.colors). */
export const MANTINE_PALETTE_KEYS = [
  'dark',
  'gray',
  'red',
  'pink',
  'grape',
  'violet',
  'indigo',
  'blue',
  'cyan',
  'teal',
  'green',
  'lime',
  'yellow',
  'orange',
];

/** Palettes proposées comme thème (toutes sauf gray et yellow). */
export const THEME_PALETTE_KEYS = MANTINE_PALETTE_KEYS.filter(
  (k) => k !== 'gray' && k !== 'yellow',
);

export const DEFAULT_THEME_COLOR = 'grape';

/** Nuance Mantine pour l’aperçu des pastilles (6 = ton principal de la palette). */
export const THEME_SWATCH_SHADE = 6;

/** value = clé palette Mantine ; label = nom affiché dans Paramètres. */
export const THEME_COLOR_OPTIONS = [
  { value: 'teal', label: 'Lagon' },
  { value: 'cyan', label: 'Aigue-marine' },
  { value: 'blue', label: 'Bleu azur' },
  { value: 'indigo', label: 'Outremer' },
  { value: 'violet', label: 'Améthyste' },
  { value: 'grape', label: 'Parme' },
  { value: 'pink', label: 'Corail' },
  { value: 'red', label: 'Grenat' },
  { value: 'orange', label: 'Ambre' },
  { value: 'lime', label: 'Chartreuse' },
  { value: 'green', label: 'Vert agate' },
  { value: 'dark', label: 'Anthracite' },
];

export const THEME_COLOR_VALUES = THEME_COLOR_OPTIONS.map((o) => o.value);

export function normalizeThemeColor(value) {
  const v = String(value || '').trim();
  return THEME_COLOR_VALUES.includes(v) ? v : DEFAULT_THEME_COLOR;
}

export function themeColorLabel(value) {
  return THEME_COLOR_OPTIONS.find((o) => o.value === normalizeThemeColor(value))?.label || 'Parme';
}

/** Couleur CSS (hex) pour ColorSwatch à partir du thème Mantine. */
export function themeSwatchColor(theme, paletteKey, shade = THEME_SWATCH_SHADE) {
  const key = normalizeThemeColor(paletteKey);
  return theme.colors[key]?.[shade] ?? theme.colors.grape[shade];
}
